import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import Slider from "react-slick";
import development1 from "../../../Assets/images/shopify-img/d1.svg";
import development2 from "../../../Assets/images/shopify-img/d2.svg";
import development3 from "../../../Assets/images/shopify-img/d3.svg";
import development4 from "../../../Assets/images/shopify-img/d4.svg";
import { tr } from 'date-fns/locale';

const OurDevelopmentProcess = () => {
    var settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        arrows:false,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      };


      const developmentProcess = [
        {
          step: '01',
          title: "Discovery",
          description: "We understand your business needs and goals to create a tailored plan.",
          icon: development1
        },
        {
          step: '02',
          title: "Design & Development",
          description: "Our team designs and builds your Shopify store with precision.",
          icon: development2
        },
        {
          step: '03',
          title: "Testing & Optimization",
          description: "Rigorous testing ensures a flawless, high-performing store.",
          icon: development3
        },
        {
          step: '04',
          title: "Launch & Support",
          description: "We launch your store and provide ongoing support for success.",
          icon: development4
        }
      ];

  return (
    <div className='bwn_our_development_process_section'>
        <Container className='bw_custome_footer_container '>
              <Row>
                            <Col sm={12} md={12} lg={12}>
                            <div className='bwn_shopify_services_section_heading text-center'>
                                <h2  className='sho_heading'>Our Development Process</h2>
                                <p  className='sho_sub_heading'>Our Roadmap to Reliable Results</p>
                            </div>
                            </Col>
                            </Row>
            <Row>
                <Col sm={12} md={12} lg={12} className='p-0'>
                <Slider {...settings}>
                   {
                    developmentProcess.map((val)=>(

                        <div className='our_development_process_box_outer'>
                        <div className='bwn_shopify_services_section_box our_development_process_box'>
                          <div className='step_box'>
                          <Image src={val.icon} className='img-fluid' />
                      <div>
                      <p>{val.step}</p>
                      </div>
                          </div>
                           
                             <h2>
                                 {val.title}
                             </h2>
                             <p>{val.description}</p>
                         </div>
                  </div>
                    ))
                   } 
     
    </Slider>
                </Col>
            </Row>
        </Container>
    </div>
  )
}

export default OurDevelopmentProcess